import { makeStyles } from '@mui/styles';
import { COLORS } from '@styles/colors';

export const useStyles = makeStyles({
  root: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
    padding: '160px',
  },
  icon: {
    marginBottom: 24,
  },
  textContainer: {
    textAlign: 'center',
  },
  title: {
    fontSize: 18,
    fontWeight: 400,
    color: COLORS.TEXT.SECONDARY,
    marginBottom: 8,
  },
  message: {
    fontSize: 16,
    fontWeight: 400,
    color: COLORS.TEXT.DISABLED,
  },
});
